<template>
  <div>
    <section class="notification">
      <div class="message">
        <h1>Maintenance mode!</h1>
        <h2>
          Sorry for the inconvenience.</h2>
          <h2>Our website is currently undergoing scheduled maintenance.
        </h2>
        <p>We will be live soon.</p>
      </div>
      <svg viewBox="110 129 449 408" id="robbie-robot">
        <g id="robbie" transform="translate(110.000000, 84.000000)">
          <rect id="body" fill="#D7D7D8" x="120.861" y="205.151" width="166.782" height="164.847" />
          <g id="leg-right" transform="translate(210.000000, 369.000000)">
            <path
              d="M14.007,1.44 C14.007,1.44 10.675,5.67 14.007,11.208 L33.72,11.208 C33.72,11.208 37.885,6.479 33.72,0.997 L15.394,0.997 L14.007,1.44 L14.007,1.44 Z"
              stroke="#25485B"
              fill="#25485B"
            />
            <path
              d="M34.461,11.142 C37.02,12.922 38.13,15.208 38.13,15.208 L9.968,15.208 C11.912,11.208 14.688,11.208 14.688,11.208 L34.461,11.142 L34.461,11.142 Z"
              id="ankle-right"
              stroke="#1C3A47"
              fill="#1C3A47"
            />
            <path
              d="M48.197,38.511 L0.185,38.511 L0.185,24.041 C0.185,18.666 4.542,14.309 9.917,14.309 L38.465,14.309 C43.84,14.309 48.197,18.666 48.197,24.041 L48.197,38.511 L48.197,38.511 Z"
              id="foot-right"
              fill="#8F97A3"
            />
            <path
              d="M32.041,14.309 C32.041,14.309 36.997,18.311 36.321,38.511 L43.53,38.511 C43.53,38.511 46.008,18.793 32.041,14.309 L32.041,14.309 Z"
              id="Shape"
              fill="#F0F4F6"
              opacity="0.25"
            />
          </g>
          <g id="leg-left" transform="translate(150.000000, 369.000000)">
            <path
              d="M14.224,1.44 C14.224,1.44 10.892,5.67 14.224,11.208 L33.937,11.208 C33.937,11.208 38.102,6.479 33.937,0.997 L15.611,0.997 L14.224,1.44 L14.224,1.44 Z"
              id="left-left"
              stroke="#25485B"
              fill="#25485B"
            />
            <path
              d="M34.678,11.142 C37.237,12.922 38.347,15.208 38.347,15.208 L10.185,15.208 C12.129,11.208 14.905,11.208 14.905,11.208 L34.678,11.142 L34.678,11.142 Z"
              id="ankle-left"
              stroke="#1C3A47"
              fill="#1C3A47"
            />
            <path
              d="M48.194,38.511 L0.377,38.511 L0.377,24.036 C0.377,18.661 4.734,14.304 10.109,14.304 L38.462,14.304 C43.837,14.304 48.194,18.661 48.194,24.036 L48.194,38.511 L48.194,38.511 Z"
              id="foot-left"
              fill="#8F97A3"
            />
          </g>
          <g id="arm-right-whole" transform="translate(264.000000, 212.000000)">
            <path
              d="M37.0884347,96.3791387 L45.1215272,105.628818 C45.1215272,105.628818 117.06798,46.8097913 32.256,8.937 L31.796,27.137 C31.796,27.137 93.241467,48.6378553 37.0884347,96.3791387 Z"
              id="arm-right"
              fill="#8F97A3"
            />
            <path
              d="M45.1717259,101.427008 L43.0210444,98.9224683 C43.0210444,98.9224683 103.596647,46.893715 32.982,21.3674175 L32.982,17.969 L34.34,18.207 C34.34,18.207 107.816438,40.7046167 45.1717259,101.427008 Z"
              id="arm-right-highlight"
              fill="#F0F4F6"
              opacity="0.25"
            />
            <path
              d="M21.810771,-7.4654489 C22.5911234,-7.88886051 44.2300143,-5.28205879 35.6043047,5.74401239 C26.9785951,16.7700836 35.6043047,37.3440159 35.6043047,37.3440159 L14.4103023,37.3440159 C14.4103023,37.3440159 -2.53441595,5.74401248 21.810771,-7.4654489 Z"
              id="shoulder"
              fill="#D7D7D8"
              transform="translate(23.151813, 14.917940) rotate(90.027002) translate(-23.151813, -14.917940) "
            />
            <path
              d="M47.7605604,32.5752608 L47.1095604,12.8722608 C47.1095604,12.8722608 42.2455604,8.86626084 36.9035604,13.2092608 L37.5085604,31.5252608 L37.9975604,32.8972608 C37.9975604,32.8972608 42.3345604,36.0872608 47.7605604,32.5752608 Z"
              id="sleeve"
              fill="#A8A8A8"
              transform="translate(42.332060, 22.705930) rotate(-316.000000) translate(-42.332060, -22.705930) "
            />
          </g>
          <g
            id="logo"
            transform="translate(255.000000, 233.000000)"
            stroke="#02A550"
            stroke-width="0.5843"
            fill="#02A550"
          >
            <path
              d="M5.364,13.512 C5.364,11.469 5.367,5.814 5.372,5.537 C5.38,5.062 5.624,4.707 5.964,4.513 C6.111,4.429 8.997,2.76 11.156,1.514 C10.168,0.943 9.435,0.519 9.435,0.519 C8.978,0.275 8.613,0.275 8.2,0.513 C6.435,1.527 1.465,4.402 1.271,4.513 C0.93,4.707 0.687,5.062 0.679,5.537 C0.674,5.814 0.671,11.469 0.671,13.512 C0.671,13.965 0.906,14.376 1.293,14.599 C3.066,15.622 8.029,18.485 8.226,18.601 C8.591,18.815 9.017,18.81 9.374,18.605 C9.803,18.358 10.438,17.992 11.153,17.579 C9.493,16.621 7.106,15.244 5.988,14.599 C5.599,14.376 5.364,13.965 5.364,13.512 L5.364,13.512 Z"
              id="Shape"
            />
            <path
              d="M21.626,5.522 C21.626,5.105 21.387,4.715 21.021,4.503 C20.655,4.292 14.129,0.519 14.129,0.519 C13.672,0.275 13.307,0.275 12.894,0.513 C12.466,0.759 11.848,1.115 11.157,1.514 C13.118,2.648 16.085,4.363 16.328,4.503 C16.694,4.714 16.933,5.104 16.933,5.522 C16.934,7.51 16.936,13.259 16.935,13.543 C16.934,13.931 16.763,14.331 16.355,14.574 C16.123,14.712 13.282,16.351 11.152,17.58 C12.124,18.141 12.847,18.559 12.919,18.602 C13.284,18.816 13.71,18.811 14.067,18.606 C15.773,17.622 20.739,14.759 21.049,14.574 C21.457,14.332 21.628,13.931 21.629,13.543 C21.629,13.259 21.626,7.51 21.626,5.522 L21.626,5.522 Z"
              id="Shape"
            />
          </g>
          <g id="head" transform="translate(112.000000, 100.000000)">
            <g id="ear-right" transform="translate(173.000000, 73.000000)">
              <path
                d="M0.507,21.664 L0.507,0.385 L8.17,0.385 C9.962,0.385 11.414,1.837 11.414,3.629 L11.414,18.42 C11.414,20.212 9.962,21.664 8.17,21.664 L0.507,21.664 L0.507,21.664 Z"
                id="Shape"
                fill="#838B92"
              />
              <rect
                id="Rectangle-path"
                fill="#333333"
                opacity="0.25"
                x="2.477"
                y="0.385"
                width="2.973"
                height="21.279"
              />
              <path
                d="M10.111,14.611 L7.84,14.611 L7.84,1.894 L7.84,1.894 C9.094,1.894 10.111,2.911 10.111,4.165 L10.111,14.611 L10.111,14.611 Z"
                id="Shape"
                fill="#F0F4F6"
                opacity="0.25"
              />
            </g>
            <g id="ear-left" transform="translate(0.000000, 73.000000)">
              <path
                d="M11.002,0.385 L11.002,21.664 L3.334,21.664 C1.542,21.664 0.09,20.212 0.09,18.42 L0.09,3.629 C0.09,1.837 1.542,0.385 3.334,0.385 L11.002,0.385 L11.002,0.385 Z"
                id="Shape"
                fill="#838B92"
              />
              <rect
                id="Rectangle-path"
                fill="#333333"
                opacity="0.25"
                x="4.45"
                y="0.385"
                width="4.411"
                height="21.279"
              />
            </g>
            <path
              d="M175.643,105.151 L8.899,105.151 L8.899,71.377 C8.899,31.961 40.852,0.008 80.268,0.008 L104.274,0.008 C143.69,0.008 175.643,31.961 175.643,71.377 L175.643,105.151 L175.643,105.151 Z"
              fill="#8F97A3"
            />
            <path
              d="M75.373,75.031 C74.619,77.388 73.865,79.746 73.11,82.103 C72.34,84.51 76.122,85.541 76.888,83.145 C77.642,80.788 78.396,78.43 79.151,76.073 C79.921,73.665 76.139,72.635 75.373,75.031 L75.373,75.031 L75.373,75.031 Z"
              id="eye-left"
              fill="#000000"
            />
            <path
              d="M108.046,76.14 C108.929,78.452 109.813,80.764 110.696,83.076 C111.587,85.408 115.376,84.396 114.474,82.034 C113.591,79.722 112.707,77.41 111.824,75.098 C110.934,72.767 107.144,73.779 108.046,76.14 L108.046,76.14 L108.046,76.14 Z"
              id="eye-right"
              fill="#000000"
            />
            <path
              d="M162.661,104.42 C162.568,37.492 134.396,10.683 122.866,2.51 C117.834,1.233 113.123,0.607 109.701,0.302 C143.872,35.48 135.889,104.457 135.889,104.457 L162.661,104.42 L162.661,104.42 Z"
              id="highlight"
              fill="#F0F4F6"
              opacity="0.25"
            />
          </g>
          <g id="clothing" transform="translate(120.000000, 204.000000)" stroke="#25485B">
            <polygon
              id="Shape"
              fill="#25485B"
              points="39.5 0.5 39.5 82.5 0.5 82.5 0.5 165.5 167.5 165.5 167.5 83.5 128.5 83.5 128.5 0.5 115.5 0.5 115.5 83.5 51.5 83.5 51.5 0.5"
            />
            <polygon
              id="pocket-left"
              fill="#467387"
              points="13.5 104.5 52.5 104.5 52.5 134.393 33 149.06 13.5 134.727"
            />
            <polygon
              id="pocket-right"
              fill="#467387"
              points="114.5 104.5 153.5 104.5 153.5 134.393 134 149.06 114.5 134.727"
            />
          </g>
          <g
            id="hand-right"
            transform="translate(297.913042, 321.122224) rotate(-168.000000) translate(-297.913042, -321.122224) translate(279.913042, 304.122224)"
            fill="#02A550"
          >
            <path
              d="M18.246,27.509 C15.725,26.013 8.751,21.868 8.413,21.659 C7.833,21.301 7.573,20.741 7.583,20.179 C7.587,19.936 7.642,15.153 7.686,11.577 C6.258,12.378 5.198,12.972 5.198,12.972 C4.563,13.357 4.295,13.807 4.285,14.492 C4.243,17.412 4.151,25.65 4.145,25.97 C4.135,26.532 4.394,27.092 4.975,27.45 C5.314,27.659 12.287,31.804 14.808,33.3 C15.367,33.632 16.046,33.643 16.605,33.329 C19.165,31.891 26.332,27.864 26.62,27.707 C27.151,27.414 27.458,26.884 27.465,26.294 C27.474,25.584 27.487,24.533 27.502,23.349 C25.104,24.695 21.657,26.632 20.042,27.539 C19.485,27.852 18.805,27.841 18.246,27.509 L18.246,27.509 Z"
              id="hand-right-wrist"
              stroke="#02A550"
              stroke-width="0.5843"
            />
            <path
              d="M10.7893536,30.5224105 C10.2209965,30.8548355 9.3678787,30.8228575 8.969,30.312 C8.88212917,30.2006528 8.79525834,30.0893066 8.70838751,29.9779612 C8.51238835,29.8382942 8.37260987,29.649506 8.28550959,29.4359511 C5.73433973,26.1661119 3.18316986,22.8969774 0.632,19.627 C0.191,19.062 0.106,18.526 0.404,17.857 C2.789,12.511 5.173,7.166 7.558,1.821 C7.771,1.342 8.341,1.13 8.819,1.097 C13.326,0.786 17.833,0.475 22.34,0.164 C23.555,0.08 24.012,1.441 23.601,2.362 C23.009,3.688 22.418,5.014 21.826,6.34 C21.545,6.968 20.764,7.097 20.176,7.011 C15.594,6.34 12.136,9.044 10.125,12.929 C9.72415828,13.7029115 8.96895587,13.801738 8.35909285,13.5193099 C8.49945227,13.0735213 8.66716545,12.6299518 8.863,12.191 C9.05902682,11.7516172 9.27731478,11.3301169 9.51556064,10.927532 C10.1383103,11.1668197 10.5754718,11.7671849 10.273,12.581 C8.69415078,16.8285322 9.12283957,20.9427956 12.5119561,24.0076561 C12.7271071,24.0320667 12.9382469,24.0930325 13.124,24.176 C17.347,26.064 21.408,24.44 24.404,21.242 C25.0003665,20.6058449 25.7621957,20.7071012 26.2817678,21.1352762 C26.0258588,21.5255534 25.7442987,21.9062951 25.437,22.275 C25.1286861,22.644923 24.8037812,22.9915431 24.4647877,23.3144922 C23.9266441,22.923762 23.6654673,22.2368468 24.177,21.537 C26.923,17.779 27.619,13.573 24.936,9.605 C24.553,9.04 24.768,8.311 25.164,7.835 C26.094,6.72 27.023,5.604 27.953,4.489 C28.736,3.55 30.025,4.227 30.395,5.134 C32.101,9.317 33.808,13.5 35.515,17.683 C35.718,18.181 35.449,18.732 35.139,19.104 C31.392,23.6 27.644,28.096 23.897,32.592 C23.557,33 22.958,33.069 22.476,32.968 C18.5804512,32.1531238 14.6849024,31.3374715 10.7893536,30.5224105 Z M27.9220461,6.79623983 L28.4653891,6.14438409 C28.1695927,6.06625606 27.8737964,5.98812803 27.578,5.91 C27.6952449,6.19725407 27.8096301,6.49322816 27.9220461,6.79623983 Z M29.3328191,6.37349644 L29.6083091,7.04871596 C29.7455219,6.88412648 29.8827501,6.71955235 30.02,6.555 C29.7909397,6.49449881 29.5618794,6.43399763 29.3328191,6.37349644 Z M21.6648847,3.13253664 L21.9719836,2.44428905 C22.0947078,2.65814065 22.2173965,2.87202772 22.34,3.086 C22.1149616,3.10150646 21.8899232,3.11701898 21.6648847,3.13253664 Z M21.5330118,1.67954722 L20.7000659,1.73702363 C20.8263447,1.45401575 20.9526496,1.17100788 21.079,0.888 C21.2302387,1.15194761 21.3816071,1.41576556 21.5330118,1.67954722 Z"
              id="hand-right-left"
            />
            <path
              d="M24.4647877,23.3144922 C24.8037812,22.9915431 25.1286861,22.644923 25.437,22.275 C25.7442987,21.9062951 26.0258588,21.5255534 26.2817678,21.1352762 C25.7621957,20.7071012 25.0003665,20.6058449 24.404,21.242 C21.408,24.44 17.347,26.064 13.124,24.176 C12.571,23.929 11.793,23.877 11.354,24.404 C10.424,25.519 9.495,26.635 8.565,27.75 C7.916,28.529 8.043,29.948 9.21,30.192 C13.632,31.117 18.054,32.043 22.476,32.968 C22.958,33.069 23.557,33 23.897,32.592 C27.644,28.096 31.392,23.6 35.139,19.104 C35.449,18.732 35.718,18.181 35.515,17.683 C33.808,13.5 32.101,9.317 30.395,5.134 C30.025,4.227 28.736,3.55 27.953,4.489 C27.023,5.604 26.094,6.72 25.164,7.835 C24.768,8.311 24.553,9.04 24.936,9.605 C27.619,13.573 26.923,17.779 24.177,21.537 C23.6654673,22.2368468 23.9266441,22.923762 24.4647877,23.3144922 Z M10.661854,27.5054806 L10.1767199,28.0875024 C10.1138133,27.8493349 10.0509066,27.6111675 9.988,27.373 C10.2086959,27.4191894 10.4334934,27.463211 10.661854,27.5054806 Z M10.4050833,28.9520969 L11.211736,29.1208944 C11.0188551,29.3522941 10.8259491,29.5836686 10.633,29.815 C10.5570278,29.5273656 10.4810556,29.2397313 10.4050833,28.9520969 Z M29.6083091,7.04871596 L29.3328191,6.37349644 C29.5618794,6.43399763 29.7909397,6.49449881 30.02,6.555 C29.8827501,6.71955235 29.7455219,6.88412648 29.6083091,7.04871596 Z M28.4653891,6.14438409 L27.9220461,6.79623983 C27.8096301,6.49322816 27.6952449,6.19725407 27.578,5.91 C27.8737964,5.98812803 28.1695927,6.06625606 28.4653891,6.14438409 Z"
              id="hand-right-righ"
            />
          </g>
          <g id="arm-left-whole" transform="translate(72.000000, 235.000000)">
            <g id="hand-left" transform="translate(24.000000, 70.000000)" fill="#02A550">
              <path
                d="M6.806,16.357 C8.524,14.149 13.282,8.04 13.52,7.745 C13.929,7.238 14.49,7.059 15.021,7.136 C15.25,7.169 19.773,7.792 23.154,8.261 C22.566,6.813 22.131,5.739 22.131,5.739 C21.842,5.091 21.448,4.784 20.801,4.693 C18.041,4.305 10.252,3.233 9.949,3.189 C9.418,3.112 8.857,3.291 8.448,3.798 C8.209,4.094 3.452,10.202 1.734,12.41 C1.353,12.9 1.261,13.542 1.492,14.108 C2.548,16.704 5.505,23.972 5.619,24.263 C5.833,24.801 6.298,25.155 6.856,25.232 C7.527,25.325 8.521,25.464 9.641,25.619 C8.653,23.187 7.231,19.692 6.565,18.055 C6.333,17.488 6.425,16.847 6.806,16.357 L6.806,16.357 Z"
                id="wrist-left"
                stroke="#02A550"
                stroke-width="0.5577"
              />
              <path
                d="M4.35623925,9.32445881 C4.0896388,8.71153918 4.2716378,7.93690313 4.915,7.554 C8.62,5.348 12.324,3.142 16.029,0.936 C16.451,0.685 17.014,0.68 17.436,0.936 C22.212,3.832 26.989,6.729 31.765,9.626 C32.169,9.871 32.484,10.342 32.456,10.83 L31.724,23.745 C31.666,24.768 30.574,25.524 29.626,24.949 C28.441,24.23 27.256,23.512 26.071,22.793 C25.543,22.473 25.263,21.822 25.43,21.219 C26.611,16.966 24.76,13.359 21.229,10.927 C20.5477098,10.4579757 20.4820298,9.6873755 20.7551094,9.09712436 C21.1537105,9.28111997 21.5470894,9.48993894 21.933,9.724 C22.3203281,9.9588861 22.6885903,10.2122148 23.0371112,10.4817737 C22.6573021,11.0040705 21.9620947,11.3099255 21.229,10.927 C17.5381808,8.99960491 13.5542894,8.91162289 10.337481,11.7402472 C10.3102963,11.8924048 10.2563093,12.0414697 10.173,12.181 C7.931,15.93 8.665,19.903 11.39,23.227 C11.9116074,23.8631855 11.7734356,24.6287228 11.3614694,25.1314141 C11.0299082,24.8474187 10.7100057,24.5412129 10.404,24.213 C10.0939734,23.8804743 9.80746981,23.5353005 9.54453863,23.1798151 C10.0437399,22.772048 10.7883882,22.6590674 11.39,23.227 C14.468,26.132 18.362,27.328 22.305,25.33 C22.847,25.055 23.555,25.076 23.995,25.548 C24.94,26.562 25.885,27.575 26.83,28.589 C27.535,29.344 27.257,30.64 26.215,30.919 C22.05,32.035 17.886,33.152 13.721,34.268 C13.253,34.393 12.702,34.271 12.365,33.909 C8.555,29.823 4.746,25.738 0.936,21.652 C0.61,21.302 0.414,20.769 0.577,20.295 C1.83642296,16.6378295 3.09665057,12.9814636 4.35623925,9.32445881 Z M24.7611977,28.4135179 L25.2775382,28.9673773 C25.3423588,28.7218393 25.4071794,28.4763697 25.472,28.231 C25.2379709,28.2937004 25.0008812,28.3543962 24.7611977,28.4135179 Z M25.0618362,29.784658 L24.3189719,29.9837817 C24.4983146,30.1761609 24.6776573,30.3685625 24.857,30.561 C24.9252787,30.302207 24.9935574,30.043414 25.0618362,29.784658 Z M28.9699281,22.922764 L29.6507839,23.3356825 C29.4117924,23.4728519 29.1728378,23.6099843 28.934,23.747 C28.9493531,23.4761328 28.9610534,23.2011673 28.9699281,22.922764 Z M30.375902,22.9194871 L30.4183397,22.1707401 C30.6228931,22.2948038 30.8274466,22.418887 31.032,22.543 C30.8133781,22.6684183 30.5946584,22.7939344 30.375902,22.9194871 Z"
                id="hand-left-whole"
              />
            </g>
            <path
              d="M26.0787907,82.6053147 L32.8113315,73.8469224 C32.8113315,73.8469224 -7.709,44.186 33.628,12.085 C33.628,12.084 30.062,1.399 23.432,0.539 C23.432,0.539 -29.3672093,45.5023147 26.0787907,82.6053147 Z"
              id="arm-left"
              fill="#8F97A3"
            />
          </g>
          <g id="shoulder-left" transform="translate(94.000000, 217.000000)">
            <path
              d="M20.123,28.384 L5.658,11.722 L11.791,6.397 C20.993,-1.592 34.929,-0.608 42.918,8.594 L42.918,8.594 L20.123,28.384 L20.123,28.384 Z"
              id="shoulder"
              fill="#D7D7D8"
            />
            <path
              d="M7.318,11.119 C7.318,11.119 1.993,11.187 0.33,17.29 L13.935,32.696 C13.935,32.696 20.193,32.963 21.24,26.245 L8.593,11.923 L7.318,11.119 L7.318,11.119 Z"
              id="sleeve"
              fill="#A8A8A8"
            />
          </g>
          <g id="bag" transform="translate(0.000000, 333.000000)">
            <path
              d="M61.59,74.923 L0.59,74.923 L0.59,29.923 C0.59,21.086 7.753,13.923 16.59,13.923 L45.59,13.923 C54.427,13.923 61.59,21.086 61.59,29.923 L61.59,74.923 L61.59,74.923 Z"
              id="Shape"
              fill="#AB444F"
            />
            <path
              d="M35.942,13.923 L26.238,13.923 L26.238,3.429 C26.238,1.672 27.662,0.248 29.419,0.248 L32.761,0.248 C34.518,0.248 35.942,1.672 35.942,3.429 L35.942,13.923 L35.942,13.923 Z"
              id="Shape"
              fill="#333333"
            />
            <path d="M1,37.5 L62,37.5" id="Shape" stroke="#333333" opacity="0.8" />
            <rect id="Rectangle-path" fill="#333333" x="14" y="31" width="6" height="17" />
            <rect id="Rectangle-path" fill="#333333" x="43" y="31" width="6" height="17" />
          </g>
          <g id="hat" transform="translate(150.000000, 49.000000)">
            <path
              d="M107.618,64.171 L0.115,64.171 L0.115,43.949 C0.115,20.17 19.392,0.893 43.171,0.893 L64.563,0.893 C88.342,0.893 107.619,20.17 107.619,43.949 L107.619,64.171 L107.618,64.171 Z"
              id="Shape"
              fill="#F2F0A1"
            />
            <path
              d="M54,1 L43.616,1 C19.837,1 1,20.17 1,43.949 L1,64 L54,64 L54,1 L54,1 Z"
              id="Shape"
              fill="#E2DE93"
            />
            <path
              d="M50.229,1.403 C50.229,1.403 37.982,12 37.528,64 L43.425,64 L50.229,1.403 L50.229,1.403 Z"
              id="Shape"
              fill="#333333"
              opacity="0.4"
            />
            <path
              d="M43.425,64 C43.425,64 39.343,34 50.229,1 L59.755,1 C59.755,1 66.105,19 64.291,64 L43.425,64 L43.425,64 Z"
              id="Shape"
              fill="#FCF59D"
            />
            <path
              d="M0.56,63.974 C0.56,63.974 4.416,76 26.642,76 L82.888,76 C82.888,76 98.31,76.014 108.063,63.767 L0.56,63.974 L0.56,63.974 Z"
              id="Shape"
              fill="#C1BC7C"
            />
          </g>
          <g id="alert" transform="translate(296.000000, 0.000000)">
            <path
              d="M139.237,7.432 L5.292,7.432 C2.49,7.432 0.221,9.771 0.221,12.662 L0.221,102.532 C0.221,105.419 2.49,107.758 5.292,107.758 L12.173,107.758 C15.129,111.478 21.389,122.003 10.888,134.967 C10.888,134.967 26.6,128.452 29.077,112.478 C29.077,112.478 30.216,109.622 33.396,107.758 L139.237,107.758 C142.039,107.758 144.312,105.419 144.312,102.532 L144.312,12.662 C144.312,9.771 142.039,7.432 139.237,7.432"
              id="bubble-shadow"
              fill="#707070"
              opacity="0"
            />
            <path
              d="M147.039,0.489 L13.094,0.489 C10.292,0.489 8.023,2.828 8.023,5.719 L8.023,95.589 C8.023,98.476 10.292,100.815 13.094,100.815 L19.975,100.815 C22.931,104.535 29.191,115.06 18.69,128.024 C18.69,128.024 34.402,121.509 36.879,105.535 C36.879,105.535 38.018,102.679 41.198,100.815 L147.039,100.815 C149.841,100.815 152.114,98.476 152.114,95.589 L152.114,5.719 C152.114,2.828 149.841,0.489 147.039,0.489"
              id="bubble"
              fill="#00A95C"
              opacity="0"
            />
            <path
              d="M92.97,19.329 L91.58,57.454 C91.546,58.315 91.208,59.06 90.562,59.688 C89.917,60.317 89.163,60.631 88.303,60.631 L75.595,60.631 C74.734,60.631 73.982,60.317 73.336,59.688 C72.691,59.06 72.351,58.315 72.318,57.454 L70.928,19.329 C70.894,18.469 71.184,17.724 71.797,17.095 C72.409,16.467 73.145,16.152 74.006,16.152 L89.891,16.152 C90.751,16.152 91.487,16.467 92.1,17.095 C92.713,17.724 93.002,18.469 92.97,19.329 Z M91.48,71.751 L91.48,82.871 C91.48,83.732 91.165,84.477 90.537,85.105 C89.908,85.734 89.163,86.048 88.303,86.048 L75.595,86.048 C74.734,86.048 73.989,85.734 73.361,85.105 C72.732,84.477 72.418,83.732 72.418,82.871 L72.418,71.751 C72.418,70.891 72.732,70.146 73.361,69.517 C73.989,68.889 74.734,68.574 75.595,68.574 L88.303,68.574 C89.163,68.574 89.908,68.889 90.537,69.517 C91.165,70.146 91.48,70.891 91.48,71.751 Z"
              id="exclaim-mark"
              fill="#F1F7F8"
              opacity="0"
            />
          </g>
        </g>
      </svg>
    </section>
  </div>
</template>
<script>
// import Vue from 'vue'

export default {
  data() {
    return {};
  },
  mounted: () => {},
  components: {},
  methods: {}
};
</script>
<style scoped>
svg {
  width: 100%;
  /* margin-top: 50px; */
}

.notification {
  width: 90%;
  background: #f8f8f8;
  padding: 10px;
  margin: auto;
  box-shadow: -11px 11px 0px 0px rgba(0, 0, 0, 0.06);
}

.message {
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  /* padding-bottom: 50px; */
  font-family: sans-serif;
  line-height: 1.4;
  color: #5b6365;
}

p {
  color: #8b8b8b;
}
</style>
